module.exports = __webpack_public_path__ + "img/Garborg_Jaerbu_og_fritenker.4000e425.jpg";